import CheckIcon from "@material-ui/icons/Check";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import BaseDataTable from "../../../../../components/modules/BaseDataTable";
import Button from "../../../../../components/elements/Button";
import SplitDomainList from "../SplitDomainList";
import classes from "../../PublicationListSelectionSlide.module.scss";
import { ListType, PublicDomainListData } from "../../../../../types/campaignTypes";
import { truncateText } from "../../../../../helpers/truncateText";

type PublicSplitDomainListsDashboardProps = {
  publicDomainLists: any[];
  selectedDomainListsIds: number[];
  selectedDomainListsGroupIds: string[];
  toggleSelectDomainLists: (payload: PublicDomainListData | PublicDomainListData[], include?: boolean) => void;
  toggleSelectDomainListGroups: (listGroupId: string) => void;
};

const PublicSplitDomainListsDashboard: FC<PublicSplitDomainListsDashboardProps> = ({
  publicDomainLists,
  selectedDomainListsIds,
  selectedDomainListsGroupIds,
  toggleSelectDomainLists,
  toggleSelectDomainListGroups,
}) => {
  const columns = [
    { key: "name", label: "Name", minWidth: 400 },
    { key: "actions", label: "Actions", minWidth: 100 },
  ] as const;

  const rows = publicDomainLists
    .filter((item) => item.listType === ListType.SPLIT)
    .map((group) => {
      const combinedPublications = group.domainLists.flatMap((dl: any) => dl.publicPublications);

      const lists = group.domainLists.map((dl: any) => ({
        beeswaxListId: dl.beeswaxListId,
        domain: dl?.publicPublications ? dl?.publicPublications[0].domain : `list - ${dl.beeswaxListId}`,
        cpm: 25,
      }));

      return {
        beeswaxListId: null,
        name: group.name,
        publicPublications: combinedPublications,
        createdAt: group.domainLists[0]?.createdAt ?? group.createdAt,
        isSplitGroup: true,
        groupId: group.id,
        lists,
      };
    })
    .sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    .map(({ groupId, name, publicPublications, lists }) => {
      const isSelected = selectedDomainListsGroupIds.includes(groupId);

      return {
        id: groupId,
        name: (() => (
          <Tooltip title={name}>
            <Typography>{truncateText(name, 100)}</Typography>
          </Tooltip>
        ))(),
        actions: (() => (
          <Button
            className={classes.selectButton}
            variant={isSelected ? "contained" : "outlined"}
            onClick={() => {
              toggleSelectDomainListGroups(groupId);
              toggleSelectDomainLists(lists, !isSelected);
            }}
          >
            {isSelected ? "Selected" : "Select"}
            <CheckIcon />
          </Button>
        ))(),
        collapsableConfigs: {
          collapsable: true,
          collapsableChild: (
            <SplitDomainList
              isDisabled={isSelected}
              domainsInList={publicPublications}
              toggleSelectDomainLists={toggleSelectDomainLists}
              selectedDomainListsIds={selectedDomainListsIds}
            />
          ),
        },
      };
    });

  return (
    <div className={classes.domainSplitListsDashboardContainer}>
      <div className={classes.header}>
        <Typography variant="h2">BrandGen Publication Lists</Typography>
        <Typography>
          These are carefully curated lists of publications that we believe have a high likelihood of accepting ad
          traffic. If you do not wish to use any of these lists, you can create your own custom list instead.
        </Typography>
      </div>

      <BaseDataTable columns={columns} rows={rows} />
    </div>
  );
};

export default PublicSplitDomainListsDashboard;
